<template lang="html">

  <section class="home">

    <encabezado :data="'home'"></encabezado>

    <home-empresa v-if="isEmpresa"></home-empresa>

    <home-alumno v-if="isAlumno"></home-alumno>

   

  </section>

</template>

<script lang="js">

  import homeAlumno from '@/components/views/home/home-alumno';
  import homeEmpresa from '@/components/views/home/home-empresa';


  import encabezado from '@/components/parts/encabezado';

  import {mapGetters,mapActions} from 'vuex'

  export default  {
    name: 'home',
    mounted(){
      if(!!!this.logged){
        this.logout();
      }
    },
    computed: {
      ...mapGetters({
        isAlumno: 'isAlumno' ,
        isEmpresa: 'isEmpresa',
        logged : 'getLogged'
      })
    },  
    methods : {
      ...mapActions(['logout'])
    },
    components :{
      'home-alumno' : homeAlumno,
      'home-empresa' : homeEmpresa,
      'encabezado' : encabezado,
    }
  }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/views/home/home.vue